import { render, staticRenderFns } from "./CardMetricaCocina.vue?vue&type=template&id=758220a2&scoped=true"
import script from "./CardMetricaCocina.vue?vue&type=script&lang=js"
export * from "./CardMetricaCocina.vue?vue&type=script&lang=js"
import style0 from "./CardMetricaCocina.vue?vue&type=style&index=0&id=758220a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758220a2",
  null
  
)

export default component.exports